import { render, staticRenderFns } from "./richCell.vue?vue&type=template&id=47ea799c&scoped=true&"
import script from "./richCell.vue?vue&type=script&lang=js&"
export * from "./richCell.vue?vue&type=script&lang=js&"
import style0 from "./richCell.vue?vue&type=style&index=0&id=47ea799c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea799c",
  null
  
)

export default component.exports